import React from 'react';
import {Box, Container, Grid} from '@material-ui/core';
import axios from 'axios';
import moment from 'moment';
import DialogClassTestDetails from './DialogClassTestDetails';
import DialogTestStart from './DialogTestStart';
import {API_URL} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';

  
  export default function Execute(props) {
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));

	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const childRef = React.useRef();
	const childRefStartTest = React.useRef();
	const [testDetail, setTestDetail] = React.useState({});
	const [currentRunningTestTitle, setCurrentRunningTestTitle] = React.useState("");
	const [currentRunningTestSession, setCurrentRunningTestSession] = React.useState("");

	function startMyTest(){		
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testcurrentrunning?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					if(response.data.responseTxt=="success"){
						setCurrentRunningTestTitle(response.data.testName);
						setCurrentRunningTestSession(response.data.testSession);
						childRefStartTest.current.handleClickOpen();
					}else{
						let testType = testDetail.scheduleId.split("-")[2];						
						window.location.href='testsimulator?classTestId='+testDetail.scheduleId+'&testType='+testType;
					}			 				
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
		}		
	}
	function deleteCurrentStartNew(){		
		if(selectedCourse>=0 && mySelectedCourses[selectedCourse].templateId){
			let axiosHeader = {
				headers:{
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};
			axios.get(API_URL+'/testrunningdelete?templateId='+mySelectedCourses[selectedCourse].templateId, axiosHeader)
				.then(response => {
					if(response && response.data && response.data.responseTxt==="invalidToken"){
						window.localStorage.clear();
						window.location.href='logout';
					}			 				
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})		
			let testType = testDetail.scheduleId.split("-")[2];
			window.location.href='testsimulator?classTestId='+testDetail.scheduleId+'&testType='+testType;
		}
	}	
	function continueCurrentTest(){	
		let testType = currentRunningTestSession.split("-")[2];
		window.location.href='testsimulator?testSession='+currentRunningTestSession+'&testType='+testType;
	}

	function showDetails(obj){
		if(obj && obj.testId>0){
			setTestDetail(obj);
			childRef.current.handleClickOpen();	
		}	
	}
	

	return (
		<div> 
				
				{(props.clasTestList && props.clasTestList!=null)?
				<Box mt={1}>
						<Grid container spacing={1} >
						{props.clasTestList.map((myCT,index)=>(	
							<Grid key={'lt'+index} item md={12} xs={12} onClick={()=>{showDetails(myCT)}} >
								<div className='dasbordlive'>
									<div className='colone'><i className='fa fa-play-circle' /></div>
									<div className='coltwo'>									
										<h3>LIVE: {myCT.testTitle}</h3>
										<p>
											Subject: {myCT.subject}, Time: {moment(myCT.testDateTime).format('DD-MM-YYYY HH:mm')}, Duration: {myCT.totalTime} min
										</p>
									</div>
								</div>
							</Grid>
						))}
						</Grid>
				</Box>
  				:null}	

				<DialogClassTestDetails toCallStartTest={startMyTest} testDetail={testDetail} ref={childRef} />
				<DialogTestStart toCallDeleteCurrentStartNew={deleteCurrentStartNew} toCallContinueCurrentTest={continueCurrentTest} currentRunningTestTitle={currentRunningTestTitle} ref={childRefStartTest}  />							

		</div>	
	);
  }